// DUPLICATE: server/src/hallmarkHolidayTypeMap.js

const HALLMARK_HOLIDAY_TYPE_MAP = {
  MONTH_AND_DAY: 'Month and Day',
  MONTH_OCCURRENCE_AND_DAY_OF_WEEK: 'Month, Occurrence and Day of Week',
};

export default HALLMARK_HOLIDAY_TYPE_MAP;



// WEBPACK FOOTER //
// ./src/hallmarkHolidayTypeMap.js